/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

/*
* Unsupervised classification block:
* uses k-means for clustering
*/
import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedOutputs } from '../block_compatibility_checks';

Blockly.Blocks['analyse_unsupervised_classification'] = {
    init: function () {
        this.appendDummyInput()
            .appendField("Unsupervised classification");
        this.appendDummyInput()
            .appendField("Number of classes: ")
            .appendField(new Blockly.FieldNumber(3, 1, 30), "classes")
        this.setInputsInline(false);
        this.setPreviousStatement(true, 'unsup');
        this.setNextStatement(true, getAllowedOutputs('unsup'));
        this.setStyle('classification');
        this.setTooltip(Blockly.Msg.UNSUPERVISED_BLOCK_TOOLTIP);
        this.setHelpUrl("");
    }
};